import { Dayjs } from "dayjs"
import { Status } from "../Status"

export const SoSummaryTableValueType = {
  TEXT: "TEXT",
  MONEY: "MONEY",
  MONEY_COLORED: "MONEY_COLORED",
  BALANCE: "BALANCE",
  DATE: "DATE",
  STATUS: "STATUS",
} as const

export type SoSummaryTableItem = {
  type?: keyof typeof SoSummaryTableValueType
  title: string
  value?: string | number | null | Dayjs | Status
  append?: string
  fallbackValue?: string
  highlighted?: boolean
}
